<template>
    <div class="content-item-container">
        <div style="margin-right: 22px; display: flex; align-items: center;">
            <div style="margin-top: 3px; margin-bottom: 0px;"><img :src="getWeatherIcon" style="width: 25px; margin-right: 3px;"></div>
            <div><span style="font-weight: bold; font-size: 15px; font-weight: bold;">{{ weather.temperature }}</span> °C</div>
        </div>
        <div style="margin-right: 22px;">
            <div style="margin-top: 3px; margin-bottom: 0px;">降雨</div>
            <div><span style="font-weight: bold; font-size: 15px;">0</span> mm</div>
        </div>
        <div style="margin-right: 22px;">
            <div style="margin-top: 3px; margin-bottom: 0px;">风速</div>
            <div><span style="font-weight: bold; font-size: 15px;">{{ weather.windPower }}</span> m/s</div>
        </div>
        <div>
            <div style="font-size: 16px;font-weight: bold; letter-spacing: 6px;">{{ time.time }}</div>
            <div>{{ time.date }}&nbsp; &nbsp;{{ time.week }}</div>
        </div>
    </div>
</template>
<script>
import good from '../assets/img/0.png';

const weekDay = new Array(7);
weekDay[0] = "星期日";
weekDay[1] = "星期一";
weekDay[2] = "星期二";
weekDay[3] = "星期三";
weekDay[4] = "星期四";
weekDay[5] = "星期五";
weekDay[6] = "星期六";

export default {
    name: 'DateTimeBox',
    props: [
        'weather',
    ],
    data() {
        return {
            time: {
                date: '',
                week: '',
                time: ''
            },
            // wether: {
            //     rain: 1.3,
            //     wind: 1.2
            // }
        }
    },
    computed: {
        getWeatherIcon() {
            return good;
        }
    },
    created() {
        this.getTime();
        setInterval(() => this.getTime(), 1000);
        
    },
    mounted(){

    },
    methods: {

        getTime() {
            var dt = new Date();
            var y = dt.getFullYear();//获取四位数年
            var m = dt.getMonth();//获取月份
            var d = dt.getDate();//获取日期
            var h = dt.getHours();//获取时
            var i = dt.getMinutes();//获取分
            var s = dt.getSeconds();//获取秒
            m +=1;
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + '' + d : d;
            h = h < 10 ? '0' + '' + h : h;
            i = i < 10 ? '0' + '' + i : i;
            s = s < 10 ? '0' + '' + s : s;

            this.time.date = y + "/" + m + "/" + d;
            this.time.time = h + ":" + i + ":" + s



            this.time.week = weekDay[dt.getDay()];

        }

    }
}
</script>
<style scoped lang="less">
.content-item-container {
    display: flex;

}
</style>